export class Solution {
    constructor(id, solution_id, parent_agent) {
        this.id = id;
        this.solution_id = solution_id;
        this.parent_agent = parent_agent;
    }
}
